window.phoneMask = phoneMask;
window.lazyLoad = lazyLoad;

import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';
window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.PhotoSwipe = PhotoSwipe;

require('./library/slick');
require('./components/menu');
require('./my_garage/my_garage');
require('jquery-lazy');
require('inputmask');
require('./page/main_page');
require('./components/form');
require('./components/tile');
require('./components/modal');
require('./components/filters');
require('./components/cart');
require('./components/services');
require('./components/search');
require('./components/files');
require('./components/cartGoodsBuy');
require('./page/good');
require('./components/cookie');
require('./components/show_modal');

import sbjs from 'sourcebuster';
window.sbjs = sbjs;
sbjs.init();

$(document).ready(function () {
    lazyLoad();
    phoneMask();

    $(document).on('click', '.js_poster', function () {
        $(this).remove()
    });

    $(document).on('click', '.js__show_more_content', function () {
        $(this).closest('.lead_item_content').toggleClass('active');
        $(this).toggleClass('active')
    })

    $(document).on('click', '.js__anker_global', function () {
        const anker = $(this).attr('data-anker');
        let top = $(`#${anker}`).offset().top - 200;
        $('body,html').animate({
            scrollTop: top
        }, 1500);
    })

    const header = $('.header').outerHeight();
    $('.main-wrap').css('padding-top', header);

    seoHeight();
    updateImageAttributes();

    $(document).on('blur', '.js__mask_phone', function () {
        const input = $(this);
        var name = input.attr('name');
        var value = input.val();

        var storedData = CheckoutStorage.getCookie(CheckoutStorage.nameStorage);
        storedData[name] = value;
        CheckoutStorage.setCookie(CheckoutStorage.nameStorage, JSON.stringify(storedData));
    });
});

function updateImageAttributes() {
    if ($('.js__gallery_good_item').length > 0) {
        $('.js__gallery_good_item').each(function () {
            const linkGallery = $(this);
            const imageURL = linkGallery.attr('data-pswp-src');

            const img = new Image();

            $(img).on('load', function () {
                const width = img.width;
                const height = img.height;

                linkGallery.attr('data-pswp-src', imageURL)
                    .attr('data-pswp-width', width)
                    .attr('data-pswp-height', height);
            });

            img.src = imageURL;
        });
    }
}

window.updateImageAttributes = updateImageAttributes;

function lazyLoad() {
    $("img.lazy").Lazy();
}

function seoHeight() {
    const h = $('.js_seo_blade').outerHeight();
    if (h >= 400) {
        $('.js_button_view_all').removeClass('d_none')
    }

    $(document).on('click', '.js_button_view_all', function () {
        $(this).toggleClass('js_active');
        $(this).closest('.section_page').find('.js_seo_blade').toggleClass('open')
    });
}

function phoneMask() {
    var imUA = new Inputmask("+38(099) 999 99 99");
    imUA.mask($(".js__mask_phone"));
}